import * as R from "ramda";
import {
  fork,
  takeEvery,
  all,
  put,
  call,
  select,
  take
} from "redux-saga/effects";
import { actions, getters } from "./model";
import { SIDEBAR_INSTANCE_ID, TASK_TYPES } from "./constants";

// import { push } from "react-router-redux";
import { apiCall } from "App/Data/sagas";
import { actions as sliderSidebarActions } from "ui-kit/SliderSidebar/model";
import {
  portalUser as getPortalUser
  // relatedAccountId
} from "redux/modules/portal/user/selectors";
// import { getCredentials } from "redux/modules/user/selectors";
import { eventDetails as getPortalEventDetails } from "redux/modules/portal/selectors";
import { registerError } from "redux/modules/errors/actions";
import { getModule } from "redux/modules/modules/module/actions";

import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

// import { getters } from "./model";

import fileRequestSagas from "./View/Details/FileRequest/sagas";
import messagesSagas from "./View/Messages/sagas";

const init = function*() {
  yield put(actions.resetData());
};

const openTaskFlyOver = function*({ payload: { taskData, taskSessionId } }) {
  yield put(actions.resetData());

  yield put(
    sliderSidebarActions.setIsDrawerOpen(true, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );

  yield put(actions.setLoading(true));
  try {
    const eventDetails = yield select(getPortalEventDetails);
    const { id: eventId } = eventDetails || {};

    // const { id } = taskData;
    // TODO: CALL TO API TO GET TASK DETAILS

    if (taskData.type === TASK_TYPES.DOCUMENT_REQUEST) {
      yield call(getModule, {
        moduleId: STANDARD_MODULE_IDS.documentRequests.id,
        options: {
          eventId
        }
      });
      yield put(actions.initFileRequest({ taskData, taskSessionId }));
    }

    yield put(
      actions.setInitialData({
        taskData,
        taskSessionId
      })
    );
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while loading session"
        }
      ])
    );
  } finally {
    yield put(actions.setLoading(false));
  }
};

const closeTaskFlyOver = function*() {
  yield put(
    sliderSidebarActions.setIsDrawerOpen(false, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const watchOpenTaskFlyOver = function*() {
  yield takeEvery(actions.openTaskFlyOver.type, openTaskFlyOver);
};
const watchCloseSessionFlyover = function*() {
  yield takeEvery(actions.closeTaskFlyOver.type, closeTaskFlyOver);
};

/*
 * Here starts the flyover actions
 */

const toggleTask = function*({ payload: { data } }) {
  try {
    const portalUser = yield select(getPortalUser);
    const eventDetails = yield select(getPortalEventDetails);
    const taskSessionId = yield select(getters.taskSessionId);

    const isViewingAsAccount = R.pathEq(
      ["active_view", "type"],
      "account"
    )(portalUser);
    const accountId = isViewingAsAccount
      ? R.path(["active_view", "id"], portalUser)
      : null;

    yield call(apiCall, {
      method: "put",
      url: `/portal/tasks/event/${eventDetails.id}${
        accountId ? `/accounts/${accountId}` : ""
      }/task/${data.id}${taskSessionId ? `/session/${taskSessionId}` : ""}`,
      data: {
        isComplete: data.is_complete ? false : true
      }
    });

    yield all([put(actions.refreshData()), put(actions.toggleTaskStatus())]);
  } catch (e) {
    yield all([
      put(
        registerError([
          {
            system: e,
            user: "An error occurred toggling task"
          }
        ])
      )
    ]);
  }
};

const watchExecuteAction = function*() {
  for (;;) {
    const action = yield take(actions.executeAction.type);
    const delegate = R.prop(action.payload.type, {
      // [TASK_TYPES.FORM]: form,
      // [TASK_TYPES.FOLLOWUP_FORM]: followupForm,
      // [TASK_TYPES.DOCUMENT_REQUEST]: documentRequest,
      // [TASK_TYPES.INVOICE]: invoice,
      // [TASK_TYPES.PEOPLE]: people,
      // [TASK_TYPES.CUSTOM_TASK]: customTask,
      // [TASK_TYPES.ASSIGNED_TASK]: assignedTask,
      [TASK_TYPES.TOGGLE_TASK]: toggleTask
      // [TASK_TYPES.OPEN_APPLICATION]: openApplication,
      // [TASK_TYPES.OPEN_FILE]: openFile,
      // [TASK_TYPES.GO_TO_PAGE]: goToPage,
      // [TASK_TYPES.GO_TO_ALERT]: goToAlert
      // [LINK_ACTIONS.OPEN_NEW_PAGE]: openFile
    });

    if (delegate) {
      yield fork(delegate, action);
    }
  }
};

const rootSaga = function*() {
  yield all([
    fork(watchInit),
    fork(watchExecuteAction),
    fork(watchOpenTaskFlyOver),
    fork(watchCloseSessionFlyover),
    fork(fileRequestSagas),
    fork(messagesSagas)
  ]);
};
export default rootSaga;
